@use '@lib/assets/styles/main.scss' as *;
@use '@lib/components/Input/input-vars' as *;

.floatingLabelRoot {
  position: relative;
  width: 100%;
}

.fieldLabelWithoutBg {
  background-color: transparent;
}

.fieldLabelBg {
  position: absolute;
  background-color: $gray0;
  top: 50%;
  height: Calc(100% - 4px);
  transform: translateY(-50%);
  left: $inputDefaultHorizontalPadding;
  right: $inputDefaultHorizontalPadding;

  &.fieldLabelBgWhenValue {
    display: none;
  }

  &.fieldLabelBgWhenLeftIcon {
    left: $inputSidePaddingWithOneIcon;
  }

  &.fieldLabelBgWhenClearNumber {
    right: $inputSidePaddingWithOneIcon;
  }

  &.fieldLabelBgWhenRightIcon {
    right: $inputSidePaddingWithOneIcon;
    &.fieldLabelBgWhenClearNumber {
      right: $inputSidePaddingWithTwoIcon;
    }
  }

  &.fieldLabelBgWhenInputNumber {
    right: $inputDefaultHorizontalPadding + $inputNumberRightIndent;
    &.fieldLabelBgWhenClearNumber {
      right: $inputSidePaddingWithOneIcon + $inputNumberRightIndent;
    }
    &.fieldLabelBgWhenRightIcon {
      right: $inputSidePaddingWithOneIcon + $inputNumberRightIndent;
      &.fieldLabelBgWhenClearNumber {
        right: $inputSidePaddingWithTwoIcon + $inputNumberRightIndent;
      }
    }
  }
}
